import React, { Fragment, useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import "../../assets/css/TrackOrder.scss";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import axios from "axios";
import { baseURL } from "../../utils";
import Logo from "../../assets/images/logo-updated.png";
import moment from "moment";
const OrderStatus = () => {
  const [orderStatus, setOrderStatus] = useState([]);
  const [loading, setLoading] = useState(false);
  const { email, orderNo } = useParams();
  const [logs, setLogs] = useState([]);
  useEffect(() => {
    const fetchOrderStatus = async () => {
      const body = {
        email: email,
        orderNo: orderNo,
      };
      try {
        setLoading(true);
        const response = await axios.post(`${baseURL}/order/status`, body);
        if (response.data.status === true) {
          const result = response.data;
          setOrderStatus(result.data);
          setLogs(result.data.logs);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    fetchOrderStatus();
  }, [email, orderNo]);

  const handleRedirect = (item) => {
    window.location.href = item;
  };

  const orderText =
    orderStatus.length !== 0 || orderStatus.status !== ""
      ? orderStatus.status === "processing" ||
        orderStatus.status === "on the way"
        ? "Your order has been placed"
        : orderStatus.status === "delivered"
        ? "Your order has been delivered"
        : orderStatus.status === "cancelled"
        ? "Your order has been cancelled"
        : orderStatus.status === "returned"
        ? "Your order has been returned"
        : "Order not found"
      : "Order not found";

  const isStatusActive = (statuses) => {
    // Ensure statuses is an array
    const statusArray = Array.isArray(statuses) ? statuses : [statuses];

    // Check if any status in the array is found in the logs
    return statusArray.some((status) =>
      logs.some((log) => log.status === status)
    );
  };
  const getLatestStatus = (status) => {
    const filteredLogs = logs.filter((log) => log.status === status);
    if (filteredLogs.length === 0) return null;

    const latestLog = filteredLogs.reduce((latest, current) =>
      moment(latest.changed_date).isAfter(current.changed_date)
        ? latest
        : current
    );

    return {
      ...latestLog,
      formattedDate: latestLog.changed_date,
    };
  };

  const isLogStatusActive = (status) => {
    const latestStatus = getLatestStatus(status);

    if (latestStatus) {
      const formattedDate = moment(latestStatus.change_date).format(
        "DD MMM YYYY, h:mm a"
      ); // Formats the date to the desired format
      return {
        isPresent: true,
        date: formattedDate,
      };
    }

    return {
      isPresent: false,
      date: null,
    };
  };

  return (
    <Fragment>
      <Helmet>
        <title>Track Your Order | D'decor Rugs</title>
        <meta property="og:title" content="Track Your Order | D'decor Rugs" />
      </Helmet>
      {loading ? (
        <div className="loading-component">
          <img src={Logo} alt="" />
        </div>
      ) : (
        <Fragment>
          {" "}
          <Header />
          <div className="intro-track-container">
            <div className="heading-track">
              <h2>
                <span
                  onClick={() => handleRedirect("/")}
                  style={{ cursor: "pointer" }}
                >
                  {" "}
                  Home
                </span>{" "}
                -{" "}
                <span
                  onClick={() => handleRedirect("/rugs")}
                  style={{ cursor: "pointer" }}
                >
                  Shop -{" "}
                </span>
                <span>Track my Order</span>
              </h2>
            </div>
          </div>
          <div className="order-status-container">
            <div className="order-id">
              <h4>Order Id : {orderNo}</h4>
              <p>{orderText}</p>
            </div>
            {orderStatus.status !== "returned" && (
              <div className="order-tracking-status">
                <div className="order-status-icon-container">
                  <div
                    className={`order-status-item ${
                      isStatusActive(["processing", "on the way", "delivered"])
                        ? "active"
                        : ""
                    }`}
                  >
                    <div className="order-status-icon">
                      <svg
                        width="64"
                        height="64"
                        viewBox="0 0 64 64"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.131 47.9984H10.0018V23.0009C10.0018 22.7357 9.89641 22.4814 9.70889 22.2938C9.52137 22.1063 9.26704 22.001 9.00185 22.001C8.73666 22.001 8.48233 22.1063 8.29482 22.2938C8.1073 22.4814 8.00195 22.7357 8.00195 23.0009V48.9983C8.00192 49.1296 8.02776 49.2596 8.078 49.3809C8.12823 49.5023 8.20188 49.6125 8.29474 49.7054C8.3876 49.7982 8.49784 49.8719 8.61917 49.9221C8.7405 49.9723 8.87053 49.9982 9.00185 49.9982H16.131C16.3962 49.9982 16.6505 49.8928 16.838 49.7053C17.0256 49.5178 17.1309 49.2634 17.1309 48.9983C17.1309 48.7331 17.0256 48.4787 16.838 48.2912C16.6505 48.1037 16.3962 47.9984 16.131 47.9984Z"
                          fill="#FCFCFC"
                        />
                        <path
                          d="M54.9972 22.001C54.8659 22.0009 54.7359 22.0268 54.6146 22.077C54.4932 22.1273 54.383 22.2009 54.2901 22.2938C54.1973 22.3866 54.1236 22.4969 54.0734 22.6182C54.0231 22.7395 53.9973 22.8696 53.9973 23.0009V47.9984H47.8681C47.6029 47.9984 47.3485 48.1037 47.161 48.2912C46.9735 48.4787 46.8682 48.7331 46.8682 48.9983C46.8682 49.2635 46.9735 49.5178 47.161 49.7053C47.3485 49.8928 47.6029 49.9982 47.8681 49.9982H54.9972C55.1286 49.9982 55.2586 49.9724 55.3799 49.9221C55.5013 49.8719 55.6115 49.7982 55.7043 49.7054C55.7972 49.6125 55.8709 49.5023 55.9211 49.381C55.9713 49.2596 55.9972 49.1296 55.9971 48.9983V23.0009C55.9972 22.8696 55.9713 22.7395 55.9211 22.6182C55.8709 22.4969 55.7972 22.3866 55.7043 22.2938C55.6115 22.2009 55.5013 22.1273 55.3799 22.077C55.2586 22.0268 55.1286 22.0009 54.9972 22.001Z"
                          fill="#FCFCFC"
                        />
                        <path
                          d="M59.9446 18.685L56.9449 9.68593C56.9092 9.60476 56.8642 9.52993 56.8231 9.45133C56.7577 9.34973 56.6746 9.26068 56.5777 9.18842L49.5784 4.18893C49.4089 4.06786 49.2057 4.00283 48.9974 4.00293H15.0008C14.7925 4.00283 14.5894 4.06786 14.4198 4.18893L7.42055 9.18842C7.25626 9.31881 7.12955 9.4905 7.0534 9.68593L4.0537 18.685C4.00512 18.8353 3.99257 18.9949 4.01707 19.1509C4.04157 19.3069 4.10243 19.4549 4.19473 19.583C4.28703 19.7112 4.40818 19.8158 4.54839 19.8884C4.6886 19.9611 4.84394 19.9997 5.00185 20.0012L58.9964 20.0013C59.1543 19.9998 59.3097 19.9611 59.4499 19.8885C59.5901 19.8158 59.7112 19.7112 59.8035 19.5831C59.8958 19.4549 59.9567 19.3069 59.9812 19.1509C60.0057 18.9949 59.9931 18.8353 59.9446 18.685ZM15.3211 6.00271H48.6771L52.8765 9.00241H11.1217L15.3211 6.00271ZM6.38941 18.0015L8.72218 11.0022H55.2761L57.6089 18.0015H6.38941Z"
                          fill="#FCFCFC"
                        />
                        <path
                          d="M31.9987 34C29.4278 34 26.9146 34.7624 24.777 36.1907C22.6394 37.619 20.9733 39.6491 19.9895 42.0243C19.0056 44.3995 18.7482 47.0131 19.2498 49.5346C19.7513 52.0561 20.9893 54.3723 22.8072 56.1902C24.6251 58.0081 26.9413 59.2461 29.4628 59.7476C31.9843 60.2492 34.5979 59.9918 36.9731 59.0079C39.3483 58.0241 41.3784 56.358 42.8067 54.2204C44.235 52.0828 44.9974 49.5696 44.9974 46.9987C44.9935 43.5524 43.6227 40.2484 41.1858 37.8115C38.749 35.3747 35.445 34.0039 31.9987 34ZM31.9987 57.9976C29.8233 57.9976 27.6968 57.3525 25.888 56.1439C24.0793 54.9354 22.6695 53.2176 21.8371 51.2078C21.0046 49.198 20.7868 46.9865 21.2112 44.8529C21.6356 42.7193 22.6831 40.7595 24.2213 39.2213C25.7595 37.6831 27.7194 36.6355 29.8529 36.2111C31.9865 35.7867 34.198 36.0046 36.2078 36.837C38.2176 37.6695 39.9354 39.0793 41.1439 40.888C42.3525 42.6968 42.9976 44.8233 42.9976 46.9987C42.9943 49.9148 41.8344 52.7105 39.7725 54.7724C37.7105 56.8344 34.9148 57.9943 31.9987 57.9976Z"
                          fill="#FCFCFC"
                        />
                        <path
                          d="M36.2918 42.9584L30.3325 48.9177L27.7068 46.2915C27.5193 46.104 27.265 45.9987 26.9998 45.9987C26.7346 45.9987 26.4803 46.104 26.2928 46.2915C26.1053 46.479 26 46.7333 26 46.9985C26 47.2636 26.1053 47.5179 26.2928 47.7054L29.6255 51.0386C29.7183 51.1315 29.8285 51.2051 29.9498 51.2554C30.0711 51.3057 30.2012 51.3315 30.3325 51.3315C30.4638 51.3315 30.5938 51.3057 30.7151 51.2554C30.8364 51.2051 30.9466 51.1315 31.0394 51.0386L37.7057 44.3723C37.7986 44.2794 37.8722 44.1692 37.9225 44.0479C37.9727 43.9266 37.9986 43.7966 37.9986 43.6653C37.9986 43.534 37.9727 43.404 37.9225 43.2827C37.8722 43.1614 37.7986 43.0512 37.7057 42.9584C37.6129 42.8655 37.5027 42.7919 37.3814 42.7416C37.2601 42.6914 37.1301 42.6655 36.9988 42.6655C36.8675 42.6655 36.7375 42.6914 36.6162 42.7416C36.4949 42.7919 36.3847 42.8655 36.2918 42.9584Z"
                          fill="#FCFCFC"
                        />
                      </svg>
                    </div>
                    <div className="order-status-title">
                      <p>Ordered</p>
                    </div>
                  </div>

                  <div
                    className={`order-status-item ${
                      isStatusActive(["on the way", "delivered"])
                        ? "active"
                        : ""
                    }`}
                  >
                    <div className="order-status-icon">
                      <svg
                        width="56"
                        height="46"
                        viewBox="0 0 56 46"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M41.3333 44.3332C44.2789 44.3332 46.6667 41.9454 46.6667 38.9998C46.6667 36.0543 44.2789 33.6665 41.3333 33.6665C38.3878 33.6665 36 36.0543 36 38.9998C36 41.9454 38.3878 44.3332 41.3333 44.3332Z"
                          stroke="#FCFCFC"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M14.6663 44.3332C17.6119 44.3332 19.9997 41.9454 19.9997 38.9998C19.9997 36.0543 17.6119 33.6665 14.6663 33.6665C11.7208 33.6665 9.33301 36.0543 9.33301 38.9998C9.33301 41.9454 11.7208 44.3332 14.6663 44.3332Z"
                          stroke="#FCFCFC"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M9.33301 38.9252C6.40767 38.7812 4.58634 38.3465 3.28501 37.0478C1.98367 35.7492 1.55167 33.9252 1.40767 30.9998M19.9997 38.9998H35.9997M46.6663 38.9252C49.5917 38.7812 51.413 38.3465 52.7143 37.0478C54.6663 35.0932 54.6663 31.9518 54.6663 25.6665V20.3332H42.133C40.1463 20.3332 39.1543 20.3332 38.3517 20.0718C37.5513 19.8117 36.8238 19.3659 36.2287 18.7708C35.6336 18.1757 35.1878 17.4482 34.9277 16.6478C34.6663 15.8452 34.6663 14.8532 34.6663 12.8665C34.6663 9.88784 34.6663 8.39984 34.2743 7.1945C33.8842 5.9939 33.2155 4.90267 32.3228 4.01002C31.4302 3.11737 30.3389 2.44864 29.1383 2.0585C27.933 1.6665 26.445 1.6665 23.4663 1.6665H1.33301M1.33301 12.3332H17.333M1.33301 20.3332H11.9997"
                          stroke="#FCFCFC"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M34.666 7H39.522C43.4047 7 45.3434 7 46.922 7.944C48.5034 8.88533 49.4234 10.5947 51.2634 14.0133L54.666 20.3333"
                          stroke="#FCFCFC"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>

                    <div className="order-status-title">
                      <p>Out for Delivery</p>
                    </div>
                  </div>
                  <div className="order-status-item">
                    <div className="order-status-icon">
                      <svg
                        width="56"
                        height="56"
                        viewBox="0 0 56 56"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2.79824 0C1.26315 0 0 1.24125 0 2.79817V29.8684C0 31.4362 1.26315 32.6647 2.79824 32.6647H31.1159C32.558 33.8297 34.4066 34.5314 36.3988 34.5314C41.0631 34.5314 44.799 30.7614 44.799 26.1332C44.799 24.6367 44.408 23.2249 43.718 22.0062L45.4607 20.2635C46.0517 19.6711 45.6244 18.6414 44.7698 18.6684C44.5278 18.6755 44.3131 18.7665 44.1445 18.94L42.6078 20.4713C41.0703 18.7858 38.8525 17.7351 36.3988 17.7351V2.79817C36.3988 1.26312 35.1594 0 33.6024 0H2.79824ZM2.79824 1.86848H13.0633V10.2666C13.0629 10.9881 13.8463 11.4372 14.4687 11.0724L18.204 8.92316L21.9374 11.0724C22.5586 11.4309 23.3353 10.9838 23.3374 10.2666V1.86848H33.6024C34.1356 1.86848 34.5321 2.29048 34.5321 2.79817V17.9447C30.7708 18.8049 28.0005 22.1479 28.0005 26.1332C28.0005 27.858 28.5186 29.4623 29.4151 30.7981H2.79824C2.28689 30.7981 1.86852 30.4016 1.86852 29.8684V2.79817C1.86852 2.28318 2.26502 1.86848 2.79824 1.86848ZM14.93 1.86848H21.4689V8.65337L18.6652 7.04191C18.3773 6.87646 18.0233 6.87646 17.7355 7.04191L14.93 8.65337V1.86848ZM36.3988 19.6017C38.3492 19.6017 40.0897 20.4521 41.2843 21.7984L36.3988 26.6783L33.3272 23.6049C32.4193 22.7627 31.1651 24.0059 32.0037 24.9283L35.7389 28.6616C36.1036 29.0272 36.6958 29.0272 37.0606 28.6616L42.3289 23.3952C42.7124 24.228 42.9305 25.1529 42.9305 26.1332C42.9305 29.7526 40.0036 32.6647 36.3988 32.6647C32.7795 32.6647 29.869 29.7343 29.869 26.1332C29.869 22.5358 32.7795 19.6017 36.3988 19.6017ZM5.60012 21.4648C5.13275 21.4648 4.6656 21.7762 4.66676 22.3999V27.0666C4.66446 28.3136 6.53574 28.3136 6.53344 27.0666V22.3999C6.53461 21.7764 6.06749 21.4648 5.60012 21.4648ZM9.33352 21.4648C8.86615 21.4648 8.399 21.7762 8.40016 22.3999V27.0666C8.39784 28.3136 10.2691 28.3136 10.2668 27.0666V22.3999C10.268 21.7764 9.80089 21.4648 9.33352 21.4648ZM13.0669 21.4648C12.5996 21.4648 12.1324 21.7762 12.1336 22.3999V27.0666C12.1312 28.3136 14.0025 28.3136 14.0002 27.0666V22.3999C14.0014 21.7764 13.5343 21.4648 13.0669 21.4648ZM17.101 48.9724C19.615 50.6648 22.2613 52.3682 24.5697 53.6718C26.878 54.9754 28.9353 55.9368 30.219 55.9997C30.2367 56.0001 30.2508 56.0001 30.268 55.9997C32.1297 55.9997 34.5406 55.3355 36.6757 54.6982C37.7433 54.3793 38.7512 54.0613 39.576 53.8304C40.4009 53.5997 40.9941 53.4713 41.2841 53.4713H44.8152C44.902 54.8789 46.0202 55.9997 47.4238 55.9997H52.302C53.7649 55.9997 54.8263 54.7947 54.9271 53.3674L55.9935 38.2318C56.1014 36.6984 54.8313 35.4683 53.3685 35.4683H47.4238C45.9297 35.4683 44.7988 36.7103 44.7988 38.1698V38.2665H41.1875L37.0476 36.4946C36.9323 36.4452 36.8067 36.4201 36.6812 36.4198H23.2679C21.3946 36.4198 19.8202 37.7521 19.5254 39.5461L11.8235 35.0836C11.0817 34.6534 10.2585 34.4763 9.45917 34.5313C9.19295 34.549 8.92887 34.5935 8.67178 34.6626C7.64339 34.9392 6.72266 35.6139 6.15247 36.6059C5.00445 38.6031 5.80155 41.0571 7.62812 42.2659C7.62812 42.2659 12.0731 45.5874 17.101 48.9724ZM9.58308 36.3907C10.0221 36.359 10.4778 36.4539 10.8938 36.6952L19.9703 41.9616C20.627 43.095 21.859 43.8684 23.268 43.8684H32.5267C33.7715 43.8684 33.7715 41.9999 32.5267 41.9999H23.268C22.1611 41.9999 21.332 41.1346 21.332 40.1478C21.332 39.1611 22.1611 38.2866 23.268 38.2866H36.4898L40.6371 40.0567C40.7524 40.1061 40.8762 40.1329 41.0016 40.1332H44.7988V51.6048H41.2842C40.7158 51.6048 39.9431 51.7879 39.073 52.0314C38.2027 52.2748 37.1965 52.5925 36.1453 52.9063C34.0528 53.531 31.8542 54.1259 30.2955 54.1259C29.4564 54.079 27.722 53.3043 25.4938 52.0459C23.2591 50.7839 20.6398 49.0998 18.1492 47.423C13.1678 44.0695 8.65429 40.7092 8.65429 40.7092C7.55841 39.911 7.14625 38.6256 7.77289 37.5354C8.16456 36.8541 8.85137 36.4447 9.58308 36.3907ZM47.4239 37.3369H53.3685C53.7838 37.3369 54.1637 37.6812 54.1342 38.1007L53.0659 53.2308C53.0253 53.8081 52.6658 54.1332 52.3021 54.1332H47.4239C47.0326 54.1332 46.6656 53.7984 46.6656 53.3001V38.1699C46.6656 37.6715 47.0253 37.3369 47.4239 37.3369ZM50.2622 50.3998C49.7468 50.3998 49.3289 50.8177 49.3289 51.3332C49.3289 51.8486 49.7468 52.2665 50.2622 52.2665C50.7777 52.2665 51.1955 51.8486 51.1956 51.3332C51.1955 50.8177 50.7777 50.3999 50.2622 50.3998Z"
                          fill="#FCFCFC"
                        />
                      </svg>
                    </div>
                    <div className="order-status-title">
                      <p>Delivered</p>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {orderStatus.status !== "returned" && (
              <div className="order-status-log-container">
                <div className="order-status-log-list">
                  <div
                    className={`order-status-log-item ${
                      isLogStatusActive("processing").isPresent ? "active" : ""
                    }`}
                  >
                    <div className="order-status-log-checkbox">
                      <div className="order-status-log-circle"></div>
                    </div>
                    <div className="order-status-log-info">
                      <div className="order-status-log-title">
                        <p>Order Placed</p>
                      </div>
                      <div className="order-status-log-date">
                        <p>
                          {isLogStatusActive("processing").isPresent
                            ? isLogStatusActive("processing").date
                            : ""}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`order-status-log-item ${
                      isLogStatusActive("on the way").isPresent ? "active" : ""
                    }`}
                  >
                    <div className="order-status-log-checkbox">
                      <div className="order-status-log-circle"></div>
                    </div>
                    <div className="order-status-log-info">
                      <div className="order-status-log-title">
                        <p>Out for Delivery</p>
                      </div>
                      <div className="order-status-log-date">
                        <p>
                          {isLogStatusActive("on the way").isPresent
                            ? isLogStatusActive("on the way").date
                            : ""}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`order-status-log-item ${
                      isLogStatusActive("delivered").isPresent ? "active" : ""
                    }`}
                  >
                    <div className="order-status-log-checkbox">
                      <div className="order-status-log-circle"></div>
                    </div>
                    <div className="order-status-log-info">
                      <div className="order-status-log-title">
                        <p>Delivered</p>
                      </div>
                      <div className="order-status-log-date">
                        <p>
                          {isLogStatusActive("delivered").isPresent
                            ? isLogStatusActive("delivered").date
                            : ""}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <Footer />
        </Fragment>
      )}
    </Fragment>
  );
};

export default OrderStatus;
